"use client";
import clsx from "clsx";
import type { ReactNode } from "react";
import { type Control, type FieldValues, type Path, useController } from "react-hook-form";

type Props<T extends FieldValues> = {
  name: Path<T>;
  control: Control<T>;
  isVertical?: boolean;
  children?: ReactNode;
  className?: string;
};
export const Checkbox = <T extends FieldValues>({ children, name, control, isVertical, className }: Props<T>) => {
  const { field } = useController({ name, control });

  return (
    <label
      className={clsx(
        className,
        "flex items-center cursor-pointer min-h-[24px] min-w-[24px] relative select-none group",
        {
          "pl-0 pt-8 justify-center": isVertical,
          "pl-8": !isVertical,
        },
      )}
    >
      {children}
      <input className="cursor-pointer opacity-0 absolute" type="checkbox" {...field} />
      <span
        className={clsx(
          "rounded-sm after:rounded-sm bg-transparent border border-primary h-6 w-6 absolute after:content-[' '] after:w-[18px] after:h-[18px] after:absolute after:top-0.5 after:left-0.5 after:bg-primary group-hover:shadow-xs group-hover:shadow-primary/75",
          {
            "top-0 left-1/2 -translate-x-1/2": isVertical,
            "left-0 top-[calc(50%-12px)]": !isVertical,
            "after:hidden": !field.value,
          },
        )}
      />
    </label>
  );
};
